import {connect} from '@modifi/redux'

import LimitConfirmationDialog, {LimitConfirmationDialogProps} from './LimitConfirmationDialog'
import {selectSavePending} from '../../store'
import {selectSavePending as selectSavePendingPreboarding} from '../../../intro/pre-underwriting-form/buyer-details/store/form'

const mapStateToProps = (
  state: Record<string, any>
): Pick<LimitConfirmationDialogProps, 'savePending'> => ({
  savePending: selectSavePending(state) || selectSavePendingPreboarding(state),
})

export const DIALOG_NAME = 'seller-trade-partner/limit-confirmation'
export default connect(mapStateToProps, null)(LimitConfirmationDialog)
